/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FilterLayersQueryDto,
  LayerPaginationResponseDto,
  LayerResponseDto,
  SyncLayerPayloadDto,
  UpdateLayerPayloadDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterLayersQueryDtoFromJSON,
    FilterLayersQueryDtoToJSON,
    LayerPaginationResponseDtoFromJSON,
    LayerPaginationResponseDtoToJSON,
    LayerResponseDtoFromJSON,
    LayerResponseDtoToJSON,
    SyncLayerPayloadDtoFromJSON,
    SyncLayerPayloadDtoToJSON,
    UpdateLayerPayloadDtoFromJSON,
    UpdateLayerPayloadDtoToJSON,
} from '../models/index';

export interface FilterLayersRequest {
    filterLayersQueryDto: FilterLayersQueryDto;
    page?: number;
    pageSize?: number;
}

export interface GetLayerByIdRequest {
    layerId: string;
}

export interface SyncLayersRequest {
    submissionId: string;
    syncLayerPayloadDto: Array<SyncLayerPayloadDto>;
}

export interface UpdateLayerRequest {
    layerId: string;
    updateLayerPayloadDto: UpdateLayerPayloadDto;
}

/**
 * 
 */
export class LayerApi extends runtime.BaseAPI {

    /**
     * Filter layers
     */
    async filterLayersRaw(requestParameters: FilterLayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LayerPaginationResponseDto>> {
        if (requestParameters['filterLayersQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterLayersQueryDto',
                'Required parameter "filterLayersQueryDto" was null or undefined when calling filterLayers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/layer/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterLayersQueryDtoToJSON(requestParameters['filterLayersQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LayerPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter layers
     */
    async filterLayers(requestParameters: FilterLayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LayerPaginationResponseDto> {
        const response = await this.filterLayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get layer by id
     */
    async getLayerByIdRaw(requestParameters: GetLayerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LayerResponseDto>> {
        if (requestParameters['layerId'] == null) {
            throw new runtime.RequiredError(
                'layerId',
                'Required parameter "layerId" was null or undefined when calling getLayerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/layer/{layerId}`.replace(`{${"layerId"}}`, encodeURIComponent(String(requestParameters['layerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LayerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get layer by id
     */
    async getLayerById(requestParameters: GetLayerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LayerResponseDto> {
        const response = await this.getLayerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sync layers
     */
    async syncLayersRaw(requestParameters: SyncLayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LayerResponseDto>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling syncLayers().'
            );
        }

        if (requestParameters['syncLayerPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'syncLayerPayloadDto',
                'Required parameter "syncLayerPayloadDto" was null or undefined when calling syncLayers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['submissionId'] != null) {
            queryParameters['submissionId'] = requestParameters['submissionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/layer/sync`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['syncLayerPayloadDto']!.map(SyncLayerPayloadDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LayerResponseDtoFromJSON));
    }

    /**
     * Sync layers
     */
    async syncLayers(requestParameters: SyncLayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LayerResponseDto>> {
        const response = await this.syncLayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update layer
     */
    async updateLayerRaw(requestParameters: UpdateLayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LayerResponseDto>> {
        if (requestParameters['layerId'] == null) {
            throw new runtime.RequiredError(
                'layerId',
                'Required parameter "layerId" was null or undefined when calling updateLayer().'
            );
        }

        if (requestParameters['updateLayerPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateLayerPayloadDto',
                'Required parameter "updateLayerPayloadDto" was null or undefined when calling updateLayer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/layer/{layerId}`.replace(`{${"layerId"}}`, encodeURIComponent(String(requestParameters['layerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLayerPayloadDtoToJSON(requestParameters['updateLayerPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LayerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update layer
     */
    async updateLayer(requestParameters: UpdateLayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LayerResponseDto> {
        const response = await this.updateLayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
